module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_768.91f1fd3f.webp";